import React from "react";
import { Helmet } from "react-helmet-async";

const PageTitle = ({ title }) => {
  return (
    <Helmet>
      <title>Hi, I'm Kevin.</title>
    </Helmet>
  );
};

export default PageTitle;
